import axios from 'axios'

const apiMst = axios.create({
  baseURL: 'https://mns.gelogs.co.th/api/mst/',
  headers: {
    'Content-Type': 'application/json',
  },
})

apiMst.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error),
)

export default apiMst
